module.exports = __webpack_public_path__ + "static/media/arrows.32380f95.svg";